<template>
  <div id="FederationPlanDetail">
    <el-drawer
        :visible.sync="showDrawer"
        direction="ltr"
        append-to-body
        size="70%"
        @close="$emit('close-draw')"
    >
      <template #title>
        <ellipsis-text :text="detailInfo.name" :show-text-count="30"></ellipsis-text>
      </template>
      <div class="detail-body">
        <div class="detail-base-info">
          <el-row class="info-row" :gutter="20">
            <el-col class="info-col" :span="8">
              <span class="label-col">创建人</span>
              <span class="value-col">{{detailInfo.creatorName}}</span>
            </el-col>
            <el-col class="info-col" :span="16">
              <span class="label-col">创建时间</span>
              <span class="value-col">{{ $fmtTime(detailInfo.createTime) }}</span>
            </el-col>
          </el-row>
          <el-row class="info-row" :gutter="20">
            <el-col class="info-col" :span="8">
              <span class="label-col">更新人</span>
              <span class="value-col">{{ detailInfo.lastModifierName}}</span>
            </el-col>
            <el-col class="info-col" :span="16">
              <span class="label-col">更新时间</span>
              <span class="value-col">{{ $fmtTime(detailInfo.lastModifiedTime) }}</span>
            </el-col>
          </el-row>
        </div>
        <el-button type="primary" icon="el-icon-plus" @click.stop="toEditPlanFile">模型</el-button>
        <gjw-dimensions @height-changed="onBoxHeightChanged">
          <div class="content-container">
            <div class="fix-flex-table">
              <gjw-table
                  ref="listTable"
                  v-loading="tableLoading"
                  :columns="tableColumns"
                  :list-data="tableData"
                  :has-page="false"
                  :max-height="tableHeight"
              >
                <template #nameSlot="{ row }">
                  <span class="table-cell-content">
                    <img class="file-img" :src="getFileIcon(row.suffix)" alt="" />
                    <span>{{ `${row.fileName}.${row.suffix}` }}</span>
                  </span>
                </template>
                <template #pathSlot="{ row }">
                  <span>{{ row.paths ? row.paths.map(f=>f.name).join('/') : '--'}}</span>
                </template>
                <template #statusSlot="{ row }">
                  <div>
                    <el-tag v-show="row.checkStatus === 'NORMAL'" type="success">正常</el-tag>
                    <el-tag v-show="row.checkStatus === 'TRANSLATE_STATUS_INVALID'" type="warning">当前启用版本未轻量化</el-tag>
                    <el-tag v-show="row.checkStatus === 'DELETED'" type="warning">文件已删除</el-tag>
                  </div>
                </template>
                <template #operateSlot="{ row , index }">
                  <div @click.stop>
                    <el-popconfirm
                        :ref="`popconfirm${index}`"
                        placement="top"
                        width="200"
                        confirm-button-text='移除'
                        cancel-button-text='取消'
                        cancel-button-type=""
                        icon="el-icon-warning"
                        title="确定移除文件？"
                        @confirm="deletePlanFile(row, index)"
                        @cancel="closePopConfirm"
                    >
                      <el-button type="text" class="ft-red" @click="closePopConfirm" slot="reference">移除</el-button>
                    </el-popconfirm>
                  </div>
                </template>
              </gjw-table>
            </div>
          </div>
        </gjw-dimensions>
      </div>
    </el-drawer>
    <!--  添加模型  -->
    <create-edit-plan ref="CreateEditPlanDialog" operate="edit" :checked-files="federationSuccessFiles" @edited="editedPlan" />
  </div>
</template>

<script>
import { federationErrorCodeMap } from '../errorCodeMap'
import gjwDimensions from '@/components/lib/GjwDimensions.vue'
import EllipsisText from '@/views/file/components/EllipsisText.vue'
import CreateEditPlan from '@/views/file/components/CreateEditPlan.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'FederationPlanDetail',
  components: { CreateEditPlan, EllipsisText, gjwDimensions },
  props: {
    spaceId: [String, Number],
  },
  data() {
    return {
      showDrawer: false,
      tableHeight: 0,
      tableLoading: false,
      planId: null,
      detailInfo: {},
      tableData: [],
    }
  },
  computed: {
    ...mapGetters({
      federationPlanFileItems: 'fileModel/federationPlanFileItems',
      federationSuccessFiles: 'fileModel/federationSuccessFiles',
    }),
    tableColumns() {
      return [
        {
          type: 'slot',
          slotName: 'nameSlot',
          label: '名称',
          prop: 'name',
          minWidth: '160px',
        },
        {
          label: '类型',
          showOverflowTooltip: false,
          prop: 'fileType',
          width: '80px',
        },
        {
          type: 'slot',
          slotName: 'pathSlot',
          label: '保存路径',
          prop: 'paths',
          minWidth: '120px',
        },
        {
          type: 'slot',
          slotName: 'statusSlot',
          label: '校验',
          width: '150px',
        },
        {
          type: 'slot',
          slotName: 'operateSlot',
          label: '操作',
          minWidth: '40px'
        },
      ]
    },
    getFileIcon() {
      return (type) => require(`@/assets/file/${type || 'default'}.png`)
    },
  },
  methods: {
    ...mapMutations({
      setFederationPlanFileItems: 'fileModel/setFederationPlanFileItems'
    }),
    onBoxHeightChanged({ newValue }) {
      this.tableHeight = newValue
    },
    openDrawer(row) {
      this.showDrawer = true
      this.planId = row.id
      this.getDetail()
    },
    closeDrawer() {
      this.showDrawer = false
    },
    // 获取模型详情
    getDetail() {
      this.tableLoading = true
      this.$api.file.federationPlanInfo(this.spaceId, this.planId).then((data) => {
        this.setFederationPlanFileItems(data.fileItems)
        this.detailInfo = data || {}
        this.tableData = data.fileItems || []
      }).catch((err) => {
        this.$matchError(err.code, federationErrorCodeMap, '获取详情失败，请联系官方客服')
        this.closeDrawer()
      }).finally(() => {
        this.tableLoading = false
      })
    },
    toEditPlanFile() {
      this.$refs.CreateEditPlanDialog?.openDialog(this.planId)
    },
    editedPlan() {
      this.getDetail()
      this.$tracks({
        event: 'modifyFederatedPlan',
        params: {
          g_c_space_id: this.spaceId,
          g_c_federated_plan_id: this.planId,
        }
      })
    },
    deletePlanFile(row, index) {
      this.$api.file.removeFederationPlanFile(this.spaceId, this.planId, row.fileId).then(() => {
        this.tableData.splice(index, 1)
        this.$message.success('移除成功')
        this.$tracks({
          event: 'modifyFederatedPlan',
          params: {
            g_c_space_id: this.spaceId,
            g_c_federated_plan_id: this.planId,
          }
        })
      }).catch((err) => {
        this.$matchError(err.code, federationErrorCodeMap, '文件移除失败')
      })
    },
    closePopConfirm() {
      // 为了解决出现多个确认气泡的情况
      this.$nextTick(() => {
        document.getElementById('FederationPlanDetail').click()
      })
    }
  },
}
</script>

<style lang="less" scoped>
.detail-body{
  padding: 0 24px;
  height: 100%;
}
.detail-base-info{
  padding-top: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid @border-color;
  .info-row{
    margin-bottom: 20px;
    line-height: 20px;
  }
  .info-col{
    display: flex;
    flex-direction: row;
  }
  .label-col{
    flex: 0 0 60px;
    font-weight: 600;
    margin-right: 20px;
  }
  .value-col{
    flex: 1;
  }
}
.content-container{
  margin-top: 16px;
  position: relative;
  height: calc(100% - 180px);
}
.file-img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 6px;
}
/deep/ .ft-red.el-button--text:focus, .ft-red.el-button--text:hover{
  color: @error-color;
}
</style>
